export const totalScore = state => {
  const total = state.score + state.life * 100;
  if (total >= 99999) return 99999;
  return total;
};

export const lifeScore = state => state.life * 100;

export const presentType = (state, getters) => {
  if (getters.totalScore >= 700) return 'l';
  if (getters.totalScore >= 400) return 'm';
  return 's';
};

export const rank = (state, getters) => {
  if (getters.totalScore >= 900) return 'gold';
  if (getters.totalScore >= 800) return 'silver';
  return 'bronze';
};
